import React, { useState, useEffect } from 'react';
import { Container, Image, Divider } from 'semantic-ui-react';
import { useNavigate } from "react-router-dom";
import '@styles/BlogBody.css';
import '@styles/GeneralTheme.css';
import CategoryGrid from '@components/CategoryGrid';

const Home = () => {
  const navigate = useNavigate();
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsDesktop(window.innerWidth >= 768);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  // Add Open Graph meta tags for home page
  useEffect(() => {
    const updateMetaTag = (property, content, isProperty = true) => {
      const attribute = isProperty ? 'property' : 'name';
      let metaTag = document.querySelector(`meta[${attribute}="${property}"]`);
      
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute(attribute, property);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute('content', content);
    };

    // Update page specific Open Graph tags
    document.title = 'Cloud CZR - Professional Salesforce Development & Technology Consulting';
    updateMetaTag('og:title', 'Cloud CZR - Professional Salesforce Development & Technology Consulting');
    updateMetaTag('og:description', 'Cloud Caesar blends ancient wisdom with modern technology. Professional Salesforce Development & Technology Consulting services.');
    updateMetaTag('og:url', window.location.href);
    updateMetaTag('og:type', 'website');
    updateMetaTag('og:image', `${window.location.origin}/assets/CloudChiRho.png`);
    updateMetaTag('og:image:alt', 'Cloud CZR, Cloudczr, cloudczr.com');
    
    updateMetaTag('description', 'Cloud Caesar blends ancient wisdom with modern technology. Professional Salesforce Development & Technology Consulting services.', false);
    updateMetaTag('twitter:title', 'Cloud CZR - Professional Salesforce Development & Technology Consulting', false);
    updateMetaTag('twitter:description', 'Cloud Caesar blends ancient wisdom with modern technology. Professional Salesforce Development & Technology Consulting services.', false);
  }, []);

  useEffect(() => {
    // Create the script element
    const script = document.createElement('script');
    script.src = 'https://static.ads-twitter.com/uwt.js';
    script.async = true;

    // Append the script to the document
    document.body.appendChild(script);

    // Initialize the Twitter tracking code
    window.twq = window.twq || function () {
      (window.twq.exe ? window.twq.exe.apply(window.twq, arguments) : window.twq.queue.push(arguments));
    };
    window.twq.version = '1.1';
    window.twq.queue = [];
    window.twq('config', 'p5ejt');

    // Cleanup function to remove the script when the component unmounts
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const categories2 = [
    {
      title: "About",
      description: "Cloud Caesar blends ancient wisdom with modern technology.",
      icon: "user",
      color: "#702963",
    },
    {
      title: "Service",
      description: "Professional Salesforce Development & Technology Consulting.",
      icon: "cogs",
      color: "#702963",
    },
    {
      title: "Vision",
      description: "The vision for the company and the things we value.",
      icon: "dna",
      color: "#702963",
    },
  ];

  return (
    <Container>
      <Image 
        src={`${process.env.PUBLIC_URL}/assets/Consulting.svg`} 
        alt="Cloud CZR, Cloudczr, cloudczr.com" 
        className="logo-image" 
        size="massive" 
        style={{ 
          width: isDesktop ? '60%' : '100%',
          display: 'block',
          margin: '0 auto'
        }} 
      />
      <Divider section />
      {/* <Button primary size='large' className="custom-button-body full-width-button" onClick={handleOpenModalNews}>
        Join Our Newsletter
      </Button>
      <Divider section /> */}

      <CategoryGrid categories={categories2} onItemClick={(category) => navigate(`/${category.title.toLowerCase().replace(/\s+/g, '-')}`)} />

      <Divider section />
      <Image src={`${process.env.PUBLIC_URL}/assets/BasilTrademark.svg`} alt="Cloud CZR, Cloudczr, cloudczr.com" className="logo-image" size="massive" style={{ width: '100%' }} />
      <Divider section />

    </Container>
  );
};

export default Home;